import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";
import { getMaterialBySlug } from "@/data/comingSoonMaterials";

export const Route = createFileRoute("/_app/coming-soon/$slug")({
  head: ({ params }) => {
    const material = getMaterialBySlug(params.slug);
    if (!material) {
      return buildHead({
        title: "Material not found | LohaLink",
        description:
          "This material page is unavailable. Explore live scrap metal, steel and mineral supply on LohaLink.",
        canonical: `/coming-soon/${params.slug}`,
        noindex: true,
      });
    }
    return buildHead({
      title: `${material.name} Supply in India — Coming Soon | LohaLink`,
      description: material.shortDesc.slice(0, 155),
      canonical: `/coming-soon/${material.slug}`,
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "Product",
          name: material.name,
          description: material.shortDesc,
          brand: { "@type": "Organization", name: "LohaLink" },
        },
      ],
    });
  },
  component: lazyRouteComponent(() => import("@/pages/ComingSoonMaterial")),
});
